﻿'use strict'

var jquery = require('jquery');
global.$ = global.jQuery = jquery;      // To get the jQuery object in the global scope because Bootstrap 4 doesn't do modules properly
//require('mmenu');

module.exports = (function () {

    // private methods


    // public methods

    /**
    * @ngdoc method
    * @name initializeNavigation
    * @description Setup the navigation for the site.  Event handlers, etc
    **/
    var initializeMobileNavigation = function () {

        console.log("topNavigation initialized");
        var $investorLogin = $("#investor-login-link");
        var investorLoginHtml = "";
        if ($investorLogin.length) {
            investorLoginHtml = "<a class='mobile-highlight-button' href='" + $investorLogin.attr("href") + "'>" + $investorLogin.html() + " <span class='fa fa-arrow-right'></span></a>";
        }

        var $menu = new Mmenu("#wo-mobile-menu", {
            "slidingSubmenus": true,
            navbar: {
                add: false
            },
            "extensions": [
                "position-top",
                "fullscreen"
            ],
            "iconPanels": true,
            "navbars": [
                {
                    "position": "bottom",
                    "content": [
                        investorLoginHtml
                    ]
                }
            ]
        });
        var API = $menu.API;

        var $hamburger = $(".hamburger");
        $hamburger.on("click", function () {
            if ($(this).hasClass('is-active')) {
                API.close();
            } else {
                API.open();
            }
        });

        API.bind("open:finish", function () {
            setTimeout(function () {
                $hamburger.addClass("is-active");
            }, 100);
        });
        API.bind("close:finish", function () {
            setTimeout(function () {
                $hamburger.removeClass("is-active");
            }, 100);
        });

        //// ADD ARIA LABELS TO MMENU ITEMS
        //var $mobileMenuPanelTitles = $('.mm-navbar__title');
        //$mobileMenuPanelTitles.each(function () {
        //    var $panelTitle = $(this);
        //    $panelTitle.attr("aria-label", "Go up one level in the menu to the " + $panelTitle.text() + " section");
        //});

        //var $mobileMenuCloseSubmenuLink = $('.mm-btn_prev.mm-navbar__btn');
        //var $mobileMenuCloseSubmenuTitles = $('.mm-btn_prev.mm-navbar__btn .mm-sronly');
        //$mobileMenuCloseSubmenuLink.each(function () {
        //    var $closePanelTitle = $(this.firstElementChild);
        //    //IN PROGRESS WORKING ON GETTING UNIQUE STRINGS FOR EACH CLOSE ARROW
        //    //var $panelTitle = $(this.getAttribute(URL));
        //    $closePanelTitle.text("Close this submenu and return to the previous section");
        //});

        // When interacting with a li that has a sub menu
        $('ul.wo-primary-navigation li:has(ul)').on('mouseover keyup click mouseleave', function (e) {
            var $subMenus = $(this).children('ul');
            // If either -
            // tabbing into the li that has a sub menu
            // hovering over the li that has a sub menu
            if (e.keyCode === 9 | e.type === 'mouseover') {

                // Show sub menu
                $subMenus.removeClass('js-hideElement');
                $subMenus.addClass('js-showElement');
                $subMenus.attr('aria-hidden', false);
            }

            // If mouse leaves li that has sub menu
            if (e.type === 'mouseleave') {

                // hide sub menu
                $subMenus.removeClass('js-showElement');
                $subMenus.addClass('js-hideElement');
                $subMenus.attr('aria-hidden', true);
            }

            // If clicking on li that has a sub menu
            if (e.type === 'click') {

                // If sub menu is already open
                if ($(this).children('a').hasClass('js-openSubMenu')) {

                    // remove Open class
                    $(this).children('a').removeClass('js-openSubMenu');

                    // Hide sub menu
                    $subMenus.removeClass('js-showElement');
                    $subMenus.addClass('js-hideElement');
                    $subMenus.attr('aria-hidden', true);


                    // If sub menu is closed
                } else {

                    // add Open class
                    $(this).children('a').addClass('js-openSubMenu');

                    // Show sub menu
                    $subMenus.removeClass('js-hideElement');
                    $subMenus.addClass('js-showElement');
                    $subMenus.attr('aria-hidden', false);

                }

            } // end click event

        });

        // Tabbing through Levels of sub menu
        // ------------------------

        // If TAB is pressed while on the last link in a sub menu
        $('ul.wo-primary-navigation li > ul > li:last-child > a').on('keydown', function (e) {

            // If tabbing out of the last link in a sub menu AND not tabbing into another sub menu
            if (!event.shiftKey && e.keyCode == 9 && $(this).parent('li').children('ul').length == 0) {

                // Close this sub menu
                $(this).parent('li').parent('ul').removeClass('js-showElement');
                $(this).parent('li').parent('ul').addClass('js-hideElement');
                $(this).parent('li').parent('ul').attr('aria-hidden', true);


                // If tabbing out of a third level sub menu and there are no other links in the parent (level 2) sub menu
                if ($(this).parent('li').parent('ul').parent('li').parent('ul').parent('li').children('ul').length > 0 &&
                    $(this).parent('li').parent('ul').parent('li').is(':last-child')) {

                    // Close the parent sub menu (level 2) as well
                    $(this).parent('li').parent('ul').parent('li').parent('ul').removeClass('js-showElement');
                    $(this).parent('li').parent('ul').parent('li').parent('ul').addClass('js-hideElement');
                    $(this).parent('li').parent('ul').parent('li').parent('ul').attr('aria-hidden', true);
                }
            }
        });

        // If SHIFT+TAB is pressed while on a nav element with a sub nav beneath it
        $('ul.wo-primary-navigation li > a').on('keydown', function (e) {

            // If tabbing backwards out of a top level nav item with a sub menu
            if (event.shiftKey && e.keyCode == 9 && $(this).parent('li').children('ul').length > 0) {

                // Close this sub menu
                $(this).parent('li').children('ul').removeClass('js-showElement');
                $(this).parent('li').children('ul').addClass('js-hideElement');
                $(this).parent('li').children('ul').attr('aria-hidden', true);
            }
        });
    };

    // Return an object exposing the public items
    return {
        initialize: initializeMobileNavigation
    };

}());